import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface CircleValidProps {
    color?: string;
    current: boolean;
    valid: boolean;
    answered: boolean;
    className?: string;
}

function CircleValid({
    color = 'currentColor',
    current = false,
    valid = false,
    answered = false,
    className = null,
}: CircleValidProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            className={classNames([
                styles.container,
                { [styles.current]: current, [className]: className !== null },
            ])}
        >
            {answered && valid === true ? (
                <>
                    <path
                        d="M9.8.3h0c5.3,0,9.7,4.3,9.7,9.7h0c0,5.3-4.3,9.7-9.7,9.7h0C4.4,19.7,0,15.3,0,10H0C0,4.7,4.4.3,9.8.3Z"
                        fill="#9efb8a"
                    />
                    <path
                        d="M13.5,7.2l-5.2,5.2-2.4-2.4"
                        fill="none"
                        stroke="#091f3f"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </>
            ) : null}
            {answered && valid === false ? (
                <>
                    <path
                        d="M10.1.3h0c5.3,0,9.7,4.3,9.7,9.7h0c0,5.3-4.3,9.7-9.7,9.7h0C4.8,19.7.4,15.3.4,10H.4C.4,4.7,4.8.3,10.1.3Z"
                        fill="#d84c4c"
                    />
                    <path
                        d="M13,7.2l-5.7,5.7M7.3,7.2l5.7,5.7"
                        fill="none"
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </>
            ) : null}
            {!answered ? <circle cx="10" cy="10" r="8" fill="#fff" stroke={color} /> : null}
        </svg>
    );
}

export default CircleValid;
